export default function SearchFooter() {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-border px-6 py-4 text-xs text-muted-foreground">
      <div className="flex items-center gap-3">
        <span>↑ ↓ Navigate</span>
        <span>Enter Open</span>
        <span>Esc Close</span>
      </div>

      <span>Search powered by Captex</span>
    </div>
  );
}